import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCurrentPresetFilters, updateFilters } from "../redux/locationsSelectorSagas";
import { Preset } from "./Preset";
import { Dropdown } from "./Dropdown";

const dropdownsProps = [
  ["Status", "statuses"],
  ["Regions", "regions"],
  ["Divisions", "divisions"],
  ["Districts", "districts"],
  ["Stores", "stores"]
];

function EditFilters() {
  const dispatch = useDispatch();
  const currentPreset = useSelector((state) => state.locations.currentPreset);

  const onOptionsChange = (data, slice) => {
    dispatch(updateCurrentPresetFilters({ data, key: slice }));
  };

  return (
    <div>
      {dropdownsProps.map((prop) => {
        let [title, slice] = prop;

        let allOptions = currentPreset.filters;
        let selected = currentPreset.filters[slice].filter((filter) => filter.checked);

        return (
          <Dropdown
            key={title}
            slice={slice}
            title={title}
            allOptions={allOptions[slice]}
            selectedOptions={selected}
            onOptionsChange={(data) => onOptionsChange(data, slice)}
          />
        );
      })}
    </div>
  );
}

function MainFilters({ openEdit, handlePopup, isCorporate }) {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.locations.filters);
  const selectedOptions = useSelector((state) => state.locations.selectedFilters);

  const onOptionsChange = (data, slice) => {
    dispatch(updateFilters({ data, key: slice }));
  };

  return (
    <div>
      <Preset openEdit={openEdit} handlePopup={handlePopup} />

      {isCorporate && (
        <Preset
          title="Corporate Presets"
          type="corporate"
          openEdit={openEdit}
          handlePopup={handlePopup}
        />
      )}

      {dropdownsProps.map((prop) => {
        let [title, slice] = prop;

        let allOptions = options;
        let selected = selectedOptions[slice];

        return (
          <Dropdown
            key={title}
            slice={slice}
            title={title}
            allOptions={allOptions[slice]}
            selectedOptions={selected}
            onOptionsChange={(data) => onOptionsChange(data, slice)}
          />
        );
      })}
    </div>
  );
}

export { MainFilters, EditFilters };
